import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_PETITION_AI_SUMMARIES_ENABLED = defineFcm('revenue_petition_ai_summaries_enabled')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experiment_name: {
					type: 'string',
					description: 'The name of the experiment to use for AI summaries.',
				},
				enabled: {
					type: 'boolean',
					default: false,
					description: 'Whether the localized membership ask headline is enabled.',
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig();
